import { render, staticRenderFns } from "./PagedQA.vue?vue&type=template&id=c6a47a6e&"
import script from "./PagedQA.vue?vue&type=script&lang=js&"
export * from "./PagedQA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports